var _circle, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDarwingToolsLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 12,
    fill: "#064AD3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.405 7.97004C16.75 9.60504 15.255 11.74 13.83 13.135C13.625 11.845 12.595 10.835 11.295 10.655C12.695 9.22505 14.845 7.71004 16.485 7.05004C16.775 6.94004 17.065 7.02504 17.245 7.20504C17.435 7.39504 17.525 7.68004 17.405 7.97004Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.39 13.5455C13.29 13.6305 13.19 13.7155 13.09 13.7955L12.195 14.5105C12.195 14.4955 12.19 14.4755 12.19 14.4555C12.12 13.9205 11.87 13.4255 11.465 13.0205C11.055 12.6105 10.545 12.3605 9.985 12.2905C9.97 12.2905 9.95 12.2855 9.935 12.2855L10.66 11.3705C10.73 11.2805 10.805 11.1955 10.885 11.1055L11.225 11.1505C12.3 11.3005 13.165 12.1455 13.335 13.2155L13.39 13.5455Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.715 14.8104C11.715 15.3604 11.505 15.8854 11.105 16.2804C10.8 16.5904 10.39 16.8004 9.89 16.8604L8.665 16.9954C7.995 17.0704 7.42 16.4954 7.495 15.8204L7.63 14.5904C7.75 13.4954 8.665 12.7954 9.635 12.7754C9.73 12.7704 9.835 12.7754 9.935 12.7854C10.36 12.8404 10.77 13.0354 11.115 13.3754C11.45 13.7104 11.64 14.1054 11.695 14.5204C11.705 14.6204 11.715 14.7154 11.715 14.8104Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarwingToolsLogo);
export default __webpack_public_path__ + "static/media/DarwingToolsLogo.24e1d9100c9014701be60383470e973d.svg";
export { ForwardRef as ReactComponent };